import { render, staticRenderFns } from "./contactselector.vue?vue&type=template&id=23959b7b"
import script from "./contactselector.vue?vue&type=script&lang=js"
export * from "./contactselector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports